import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

// eslint-disable-next-line import/no-cycle
import BlockBuilder from '../../BlockBuilder';
import { styles } from '../../../styles';

const Hr = styled.hr`
  border-color: ${({ theme }) => theme.colors.border};
  margin-bottom: ${styles.spacing['spacing-md']};
`;

function BlockBuilderPrivacyPolicy({ value }) {
  const { tt, localizeDate } = useUiComponentsInternationalContext();

  return (
    <>
      <h1>
        {tt(s => s.blockBuilderPrivacyPolicyComponent.privacyPolicyHeader)}
      </h1>
      <h2>{tt(s => s.blockBuilderPrivacyPolicyComponent.contentsHeader)}</h2>
      <ul>
        {value.privacyRef.map(({ _id, title }) => (
          <li key={_id}>
            <AnchorLink to={`#_${_id}`} title={title} />
          </li>
        ))}
      </ul>
      <Hr />
      <h2>{value.privacyTitle}</h2>
      <p>
        {tt(s => s.blockBuilderPrivacyPolicyComponent.documentWasLastUpdated, {
          date: localizeDate(value.privacyDate, {
            month: 'long',
            year: 'numeric',
            day: 'numeric',
            timeZone: 'UTC',
          }),
        })}
      </p>
      {value.privacyRef.map(({ _id, title, editor }) => (
        <section key={_id} id={`_${_id}`}>
          <h2>{title}</h2>
          <BlockBuilder blocks={editor} />
        </section>
      ))}
    </>
  );
}

BlockBuilderPrivacyPolicy.propTypes = {
  value: PropTypes.shape({
    privacyTitle: PropTypes.string,
    privacyDate: PropTypes.string,
    privacyRef: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string,
        title: PropTypes.string,
        editor: PropTypes.arrayOf(PropTypes.shape({})),
      })
    ),
  }).isRequired,
};

export default BlockBuilderPrivacyPolicy;
